import { ConnectComponent } from '../../_components/ConnectComponent'
import { ContactDataView } from './ContactData.view'
import { ContactDataPresenter } from './ContactData.presenter'

export const ContactData = ConnectComponent(
  ContactDataView,
  ContactDataPresenter,
)
